import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { RealtimeProvider } from "@/context/RealtimeContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Join from "@/pages/Join";
import Layout from "@/components/Layout";
import Console from "@/pages/Console";
import Agents from "@/pages/Agents";
import ROIEconomics from "@/pages/ROIEconomics";
import Approvals from "@/pages/Approvals";
import Billing from "@/pages/Billing";
import SpawnTree from "@/pages/SpawnTree";
import Treasury from "@/pages/Treasury";
import Inbox from "@/pages/Inbox";
import Orders from "@/pages/Orders";
import Audit from "@/pages/Audit";
import Team from "@/pages/Team";
import Deployments from "@/pages/Deployments";
import LaunchReadiness from "@/pages/LaunchReadiness";
import Guide from "@/pages/Guide";
import AdStudio from "@/pages/AdStudio";
import LeadSources from "@/pages/LeadSources";
import Autonomy from "@/pages/Autonomy";
import Outreach from "@/pages/Outreach";
import DemoPreview from "@/pages/DemoPreview";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#080B11] text-cyan-400 font-mono text-sm">
        INITIALIZING CONSOLE…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <RealtimeProvider>
        <Toaster theme="dark" position="top-right" richColors closeButton />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/join" element={<Join />} />
            <Route path="/payment/:result" element={<PaymentResult />} />
            <Route path="/preview/:id" element={<DemoPreview />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/console" element={<Console />} />
              <Route path="/agents" element={<Agents />} />
              <Route path="/roi" element={<ROIEconomics />} />
              <Route path="/approvals" element={<Approvals />} />
              <Route path="/spawn-tree" element={<SpawnTree />} />
              <Route path="/treasury" element={<Treasury />} />
              <Route path="/inbox" element={<Inbox />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/deployments" element={<Deployments />} />
              <Route path="/launch" element={<LaunchReadiness />} />
              <Route path="/guide" element={<Guide />} />
              <Route path="/ad-studio" element={<AdStudio />} />
              <Route path="/lead-sources" element={<LeadSources />} />
              <Route path="/outreach" element={<Outreach />} />
              <Route path="/autonomy" element={<Autonomy />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/team" element={<Team />} />
              <Route path="/audit" element={<Audit />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </RealtimeProvider>
    </AuthProvider>
  );
}

export default App;
